export default __webpack_public_path__ + "static/media/ai1Kit.c91b636f.png";